import React from 'react';
import merge from 'classnames';

import { Header } from './Header';
import { LeanForwardStatus } from './LeanForwardStatus';
import { Status } from './Status';

import styles from './ContentCard.module.scss';

export type Props = React.HTMLAttributes<HTMLDivElement> & {
  type?: 'light' | 'regular';
  className?: string;
};

export const ContentCard = ({ type = 'regular', ...props }: Props) => (
  <section
    data-testid="content-card"
    {...props}
    className={merge(styles.container, styles[type], props.className)}
  >
    {props.children}
  </section>
);

ContentCard.Header = Header;
ContentCard.Status = Status;
ContentCard.LeanForwardStatus = LeanForwardStatus;
